(function () {
    'use strict';

    angular
        .module('iMatApp')
        .directive('stripeRotator', stripeRotatorDirective);

    stripeRotatorDirective.$inject = ['$window'];

    function stripeRotatorDirective($window) {
        var directive = {
            link: link,
            restrict: 'A',
            scope: {
                stripeUrl: "=",
                numberOfFrames: "@",
                loaded: "&",
                error: "&"
            },
            template: '<img ng-src="{{stripeUrl}}" image-events image-load="stripeLoaded($event)" image-error="error($event)" style="display:none;" />'
        };
        return directive;

        function link(scope, element) {
            scope.stripeLoaded = stripeLoaded;
            scope.$on("$destroy", destroy);

            // -------------------------------------------------------------------------------------

            function stripeLoaded($event) {
                initModelRotator(element, scope.stripeUrl, scope.numberOfFrames);
                scope.loaded({ $event: $event });
            }

            function destroy() {
                element.off(); // removes all handlers attached to the elements
            }
        }

        function initModelRotator(element, previewUrl, framesNumber) {

            var _framesNumber = parseInt(framesNumber);
            var _frameWidthPercent = 100 / (_framesNumber - 1);

            var _doDrag = false;
            var _mouseStartXPos = 0;
            var _currentStripeFrameIdx = 0;
            var _initialFrameIdx = 0;

            var _framesPassed = 0;

            initPlaceholder(element, previewUrl);

            setStripeFrameByIdx(element, _currentStripeFrameIdx);

            function initPlaceholder(element, stripeUrl) {
                var backgroundSizePercents = _framesNumber * 100;
                element.css('touch-action', 'none');

                if (angular.isString(stripeUrl) && stripeUrl.length > 0) {
                    element.css('background-image', "url('" + stripeUrl + "')");
                    element.css('background-size', backgroundSizePercents + "%");
                } else {
                    element.css('background-image', "none");
                }
                element.off();

                subscribeOnEvents(element);
            }

            function subscribeOnEvents(element) {
                //taken from
                //http://isabelcastillo.com/detect-touch-pointer-events-jquery-windows-phone-8-1-ie-11
                //order important - in IE11 pointerEnabled and msPointerEnabled both true
                if ($window.navigator.pointerEnabled) {
                    //IE11 mouse and touch
                    element.on("pointerdown", function (e) {
                        startRotation(e.originalEvent.pageX);
                        return false;
                    });
                    element.on("pointerup", function (e) {
                        stopRotation();
                        return false;
                    });
                    element.on("pointerout", function (e) {
                        stopRotation();
                        return false;
                    });
                    element.on("pointermove", function (e) {
                        doRotation(e.originalEvent.pageX);
                        return false;
                    });
                } else if ($window.navigator.msPointerEnabled) {
                    //IE10 mouse and touch
                    element.on("MSPointerDown", function (e) {
                        startRotation(e.originalEvent.pageX);
                        return false;
                    });
                    element.on("MSPointerUp", function (e) {
                        stopRotation();
                        return false;
                    });
                    element.on("MSPointerOut", function (e) {
                        stopRotation();
                        return false;
                    });
                    element.on("MSPointerMove", function (e) {
                        doRotation(e.originalEvent.pageX);
                        return false;
                    });
                } else {
                    //non-IE touch
                    element.on("touchstart", function (e) {
                        startRotation(e.originalEvent.touches[0].pageX);
                        return false;
                    });
                    element.on("touchend", function (e) {
                        stopRotation();
                        return false;
                    });
                    element.on("touchmove", function (e) {
                        doRotation(e.originalEvent.touches[0].pageX);
                        return false;
                    });

                    //non-IE desktop
                    element.on("mousedown", function (e) {
                        startRotation(e.pageX);
                        return false;
                    });

                    element.on("mouseup", function (e) {
                        stopRotation();
                        return false;
                    });

                    element.on("mouseleave", function (e) {
                        stopRotation();
                        return false;
                    });

                    element.on("mousemove", function (e) {
                        doRotation(e.pageX);
                        return false;
                    });
                }

                element.on('dragstart', documentOnDragStartHandler);
            }

            function startRotation(mouseXPos) {
                _mouseStartXPos = mouseXPos;
                _framesPassed = 0;
                _doDrag = true;
            }

            function stopRotation() {
                if (!_doDrag) {
                    return;
                }
                _doDrag = false;
                _initialFrameIdx = _currentStripeFrameIdx;
            }

            function doRotation(mouseXPos) {
                if (!_doDrag) {
                    return;
                }
                var frameOffset = getFramesOffset(mouseXPos);
                setStripeFrameByIdx(element, _initialFrameIdx + frameOffset);
                _framesPassed = frameOffset;
            }

            function getFramesOffset(currentMouseXPos) {
                var ratio = 0.75;
                var frameWidthPercent = 100;
                var sectorWidth = frameWidthPercent / _framesNumber * ratio;

                var mouseOffset = (currentMouseXPos - _mouseStartXPos) / _mouseStartXPos * 100;
                var result = 0;
                if (mouseOffset !== 0) {
                    result = Math.floor(mouseOffset / sectorWidth);
                }

                return result;
            }

            function setStripeFrameByIdx(element, frameIdx) {
                _currentStripeFrameIdx = normalizeStripeFrameIdx(frameIdx);
                var framePosition = _currentStripeFrameIdx * _frameWidthPercent;
                element.css('background-position', framePosition + '% 50%');
            }

            function documentOnDragStartHandler(e) {
                return false;
            }

            function normalizeStripeFrameIdx(frameIdx) {
                var frameIdxToSet = frameIdx % _framesNumber;
                if (frameIdx < 0) {
                    frameIdxToSet = frameIdxToSet === 0 ? -_framesNumber + 1 : frameIdxToSet;
                    frameIdxToSet = _framesNumber + frameIdxToSet;
                }
                return frameIdxToSet;
            }
        }
    }

})();